import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: 200px;
  width: 800px;

  @media (max-width: 768px) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border: 0px solid ${({ theme }) => theme.colors.GREY_HEAVY};
  border-radius: 12px;
  min-height: 131px;
  width: 100%;
  box-sizing: border-box;
  padding: 50px 0 0 0;
`;

export const ResultContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.WHITE};
  border: 0px solid #ececec;
  border-radius: 8px;
  overflow: hidden;
  justify-content: center;
  margin: 6px 10px;
  padding: 20px 20px 30px 20px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
`;

export const ChartContainer = styled.div`
`;


export const SectionTitle = styled.div`
  // background-color: ${({ theme }) => theme.colors.WHITE};
  display: flex;
  width: 100%;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.BLACK};
  padding: 50px 0 0 20px;
  font-weight: bold;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;
`;

export const TitleSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Title = styled.span`
  padding: 8px 0 8px 3px;
  font-size: 18px;
  font-weight: bold;
`;

export const NeedLogin = styled.span`
  padding: 8px 20px;
  font-size: 16px;
  word-break: break-word;
  display: inline-block;
  color: ${({ theme }) => theme.colors.RED};
  font-weight: bold;
`;

export const RequireMark = styled.span`
  padding-left: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.RED};
`;

export const NoticeTitle = styled.div`
  font-size: 13px;
  margin-top: 8px;
  margin-bottom: 0px;
  padding: 0 20px;
  line-height: 1.5;
`;

export const NoAnswers = styled.div`
  font-size: 13px;
  margin-top: 8px;
  margin-bottom: 0px;
  padding: 0 20px;
  color: ${({ theme }) => theme.colors.RED};
  line-height: 1.5;
`;